import { Box, BoxProps } from '@chakra-ui/react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { FilterItem } from '@/components/ui/features/library/LibraryFilter/components/FilterItem';
import { Filters } from '@/components/ui/features/library/LibraryFilter/components/Filters';
import { FilterSubjects } from '@/components/ui/features/societies/PublisherFilter/components/FilterSubjects';
import { LibraryFilter as LibraryFilterEnum } from '@/enums/LibraryFilter';

export const PublisherFilter: FC<BoxProps> = (props) => {
  const { t } = useTranslation();

  return (
    <Box {...props}>
      <Box h="full" overflowY="auto" layerStyle="blackScrollbar">
        <Filters allowToggle reduceMotion>
          <FilterItem title={t('library.filter.subject')} parameter={LibraryFilterEnum.Subject}>
            <FilterSubjects />
          </FilterItem>
        </Filters>
      </Box>
    </Box>
  );
};
